import React from 'react';
import {
  Box,
  Typography,
  CircularProgress,
  LinearProgress,
  Button,
} from '@mui/material';
import AutoGraphIcon from '@mui/icons-material/AutoGraph';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
import SettingsIcon from '@mui/icons-material/Settings';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CachedIcon from '@mui/icons-material/Cached';
import './BuslogPreparationStepper.css';

const STEP_ICONS = [
  <CachedIcon />,
  <CloudDownloadIcon />,
  <InsertDriveFileIcon />,
  <SettingsIcon />,
  <InsertDriveFileIcon />,
  <CachedIcon />,
  <AutoGraphIcon />,
  <CheckCircleIcon />,
];


const BuslogPreparationStepper = ({
  isPreparing,
  isPrepError,
  prepError,
  taskId,
  statusData,
  progress,
  activeStep,
  currentMessage,
  steps,
  retry,
}) => {
  return (
    <Box className="prep-stepper-root">
      {isPreparing && (
        <Box className="prep-stepper-content">
          {/* Progress bar */}
          {progress !== undefined && (
            <Box className="prep-progress-card">
              <Box className="prep-progress-header">
                <Typography variant="body2" className="prep-progress-label">
                  Overall Progress
                </Typography>
                <Typography variant="body2" className="prep-progress-pct">
                  {progress}%
                </Typography>
              </Box>
              <LinearProgress
                variant="determinate"
                value={progress}
                className="prep-progress-bar"
              />
            </Box>
          )}

          {/* Steps */}
          <Box className="prep-steps">
            {steps.map((step, index) => {
              const isCompleted = activeStep > index;
              const isActive = activeStep === index;
              const stateClass = isCompleted
                ? 'completed'
                : isActive
                  ? 'active'
                  : 'pending';

              return (
                <Box key={step.label} className="prep-step-row">
                  <Box className={`prep-step-icon ${stateClass}`}>
                    {isCompleted ? (
                      <CheckCircleIcon fontSize="small" />
                    ) : (
                      React.cloneElement(STEP_ICONS[index], { fontSize: 'small' })
                    )}
                  </Box>

                  <Box className="prep-step-text">
                    <Typography variant="body2" className={`prep-step-label ${stateClass}`}>
                      {step.label}
                    </Typography>
                    <Typography variant="caption" className="prep-step-desc">
                      {isActive ? (currentMessage || step.description) : step.description}
                    </Typography>
                  </Box>

                  {isActive && (
                    <CircularProgress size={18} thickness={5} className="prep-step-spinner" />
                  )}
                  {isCompleted && (
                    <Typography variant="caption" className="prep-step-done-tag">
                      Done
                    </Typography>
                  )}
                </Box>
              );
            })}
          </Box>

          {/* Task ID */}
          {taskId && (
            <Typography variant="caption" className="prep-task-id">
              Task ID: {taskId}
            </Typography>
          )}
        </Box>
      )}

      {isPrepError && (
        <Box className="prep-error">
          <AutoGraphIcon className="prep-error-icon" />
          <Typography variant="subtitle1" className="prep-error-title">
            Error Preparing File
          </Typography>
          <Typography variant="body2" className="prep-error-msg">
            {prepError?.message || statusData?.error || statusData?.message || 'An unexpected error occurred'}
          </Typography>
          {taskId && (
            <Typography variant="caption" className="prep-task-id">
              Task ID: {taskId}
            </Typography>
          )}
          <Button variant="contained" size="small" onClick={retry} className="prep-error-retry">
            Retry
          </Button>
        </Box>
      )}
    </Box>
  );
};

export default BuslogPreparationStepper;
